import { render, staticRenderFns } from "./ModalTarea.vue?vue&type=template&id=b6b5d536&"
import script from "./ModalTarea.vue?vue&type=script&lang=js&"
export * from "./ModalTarea.vue?vue&type=script&lang=js&"
import style0 from "./ModalTarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports